import "./Private.css";
import privateLogo from "../../../../Assets/Images/private.svg";
import React from "react";
import numimg1 from "../../../../Assets/Images/01.png";
import numimg2 from "../../../../Assets/Images/02.png";
import numimg3 from "../../../../Assets/Images/03.png";


export default function Private() {
  return (
    <div className="private">
      <div className="container">
        <img src={privateLogo} alt="" className="private-logo" />
        <h5 className="private-title">Your Brand, Our Quality</h5>
       <div className="private-blok">
      <img src={numimg1} alt="" className="private-thumb" />
     <p className="private-text">
          We master at creating unbeatable quality with advanced tech, from
          procurement to cleaning,sorting & packaging, we’ve got it all covered
          to take your brand to next level.
        </p>
        </div>
        <div className="private-blok private-rightblok">
        <p className="private-subtext">
          Our skilled, dedicated and experienced team, our commitment to
          quality, Hygiene,Our tech & infra , our precision along with Our
          Ethical values & willingness to create relationships Sets us apart
          from our competition
        </p>
        <img src={numimg2} alt="" className="private-thumb" />

</div>
<div className="private-blok">
      <img src={numimg3} alt="" className="private-thumb" />
        <p className="private-info">
          For us, Providing Quality results and experience in most reasonable &
          competitive rates is primary. In a nut shell, For us, You come first.
        </p>
      
        </div>
        <div className="private-buttons">
             <a href="https://wa.me/918888877444" className="private-btn">
                Get a quote
            </a>
            <a href="#" className="private-link">
                Learn more
            </a>
        </div></div>
    </div>
  );
}
